// Per-language locale bundles for third-party UI libraries. English is each
// library's built-in default, so languages missing here fall back to it.
import deCalendar from '@fullcalendar/core/locales/de';
import esUS from '@fullcalendar/core/locales/es-us';
import frCACalendar from '@fullcalendar/core/locales/fr-ca';
import jaCalendar from '@fullcalendar/core/locales/ja';
import ptBRCalendar from '@fullcalendar/core/locales/pt-br';
import zhCNCalendar from '@fullcalendar/core/locales/zh-cn';
import zhTWCalendar from '@fullcalendar/core/locales/zh-tw';
import {
  deDE as deDataGrid,
  esES as esDataGrid,
  frFR as frDataGrid,
  jaJP as jaDataGrid,
  ptBR as ptBRDataGrid,
  zhCN as zhCNDataGrid,
  zhTW as zhTWDataGrid,
} from '@mui/x-data-grid/locales';
import {
  deDE as deDatePicker,
  esES as esDatePicker,
  frFR as frDatePicker,
  jaJP as jaDatePicker,
  ptBR as ptBRDatePicker,
  zhCN as zhCNDatePicker,
  zhTW as zhTWDatePicker,
} from '@mui/x-date-pickers/locales';
import { de, enUS, es, frCA, ja, ptBR, zhCN, zhTW } from 'date-fns/locale';

const LIBRARY_LOCALES = {
  'en-US': {
    dateFns: enUS,
  },
  'es-US': {
    dateFns: es,
    dataGrid: esDataGrid,
    datePicker: esDatePicker,
    fullCalendar: esUS,
  },
  'fr-CA': {
    dateFns: frCA,
    dataGrid: frDataGrid,
    datePicker: frDatePicker,
    fullCalendar: frCACalendar,
  },
  'zh-CN': {
    dateFns: zhCN,
    dataGrid: zhCNDataGrid,
    datePicker: zhCNDatePicker,
    fullCalendar: zhCNCalendar,
  },
  'zh-TW': {
    dateFns: zhTW,
    dataGrid: zhTWDataGrid,
    datePicker: zhTWDatePicker,
    fullCalendar: zhTWCalendar,
  },
  'de-DE': {
    dateFns: de,
    dataGrid: deDataGrid,
    datePicker: deDatePicker,
    fullCalendar: deCalendar,
  },
  'ja-JP': {
    dateFns: ja,
    dataGrid: jaDataGrid,
    datePicker: jaDatePicker,
    fullCalendar: jaCalendar,
  },
  'pt-BR': {
    dateFns: ptBR,
    dataGrid: ptBRDataGrid,
    datePicker: ptBRDatePicker,
    fullCalendar: ptBRCalendar,
  },
};

export const getDateFnsLocale = (lang) => LIBRARY_LOCALES[lang]?.dateFns;

export const getDataGridLocaleText = (lang) =>
  LIBRARY_LOCALES[lang]?.dataGrid?.components.MuiDataGrid.defaultProps
    .localeText;

export const getDatePickerLocaleText = (lang) =>
  LIBRARY_LOCALES[lang]?.datePicker?.components.MuiLocalizationProvider
    .defaultProps.localeText;

export const getFullCalendarLocale = (lang) =>
  LIBRARY_LOCALES[lang]?.fullCalendar;
